export default __webpack_public_path__ + "static/media/padel-champions-cover.b11e62c5.png";